import gql from 'graphql-tag';

export default gql`
  mutation stopEvent($eventId: ID!, $channelIds: [Int]!) {
    eventStop(eventId: $eventId, channelIds: $channelIds)
  }
`;
